import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ListItemIcon, ListItemText, MenuList, useTheme } from '@mui/material';
import {
    AddLocationAlt,
    ControlPoint,
    MenuBook,
    Settings,
    Work,
} from '@mui/icons-material';
import MenuItem from '@/components/ui/MenuItem/MenuItem';
import { useCompany } from '@/providers/CompanyProvider/CompanyProvider';
import { styles } from './styles';

const actionItems = [
    { route: '/new_job', title: 'New Job', icon: ControlPoint },
];

const menuItems = [
    { route: '/jobs', title: 'Jobs', icon: Work },
    { route: '/locations', title: 'Locations', icon: AddLocationAlt },
    { route: '/pricebooks', title: 'Pricebook', icon: MenuBook },
    { route: '/admin', title: 'Admin', icon: Settings },
];

const defaultMapping = { location: '/', route: '/jobs' };

interface Props {
    onItemClick?: () => void;
}

const NavDrawer = ({ onItemClick }: Props = {}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const [currentRoute, setCurrentRoute] = useState(location.pathname);
    const companyContext = useCompany();

    const company = companyContext.state.company;
    const showPricebooks = company?.marketplace_side === 'Repairer';

    useEffect(() => {
        setCurrentRoute(location.pathname);
    }, [location]);

    const handleClick = (path: string) => {
        setCurrentRoute(path);
        navigate(path);
        onItemClick?.();
    };

    const filteredMenu = menuItems.filter((item) =>
        item.route === '/pricebooks' ? showPricebooks : true,
    );

    return (
        <MenuList sx={styles.list}>
            {actionItems.map(({ route, title, icon: Icon }) => (
                <MenuItem
                    key={route}
                    sx={styles.actionItem}
                    onClick={() => handleClick(route)}
                >
                    <ListItemIcon>
                        <Icon sx={{ color: theme.palette.blue[700] }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{title}</ListItemText>
                </MenuItem>
            ))}
            {filteredMenu.map(({ route, title, icon: Icon }) => {
                const selected =
                    currentRoute === route ||
                    (currentRoute === defaultMapping.location && route === defaultMapping.route);
                const color = selected
                    ? theme.palette.blue[700]
                    : theme.palette.grey[700];
                return (
                    <MenuItem
                        key={route}
                        sx={styles.menuItem}
                        onClick={() => handleClick(route)}
                    >
                        <ListItemIcon>
                            <Icon sx={{ color }} fontSize="small" />
                        </ListItemIcon>
                        <ListItemText sx={{ color }}>{title}</ListItemText>
                    </MenuItem>
                );
            })}
        </MenuList>
    );
};

export default NavDrawer;
